/* ------------------------------------------------------------------ *
 * Shared mono legend line — the "PEYTON, CO · 6,800 FT" treatment.
 * Standard footer/section-boundary device site-wide: a rust dot +
 * letter-spaced uppercase mono line. Extracted from Footer's existing
 * markup so every section that wants this device uses one definition.
 * ------------------------------------------------------------------ */
export default function MonoLegend({ children, dot = true, className = "" }) {
  return (
    <div
      className={`flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.16em] text-ink-dim ${className}`}
    >
      {dot && <span className="h-1.5 w-1.5 rounded-full bg-rust" />}
      {children}
    </div>
  );
}
